import React from 'react';
import styled from 'styled-components';
// ANTD
import SavedLineItemsForm from 'components/forms/SavedLineItemsForm';
import LineItemsForm from 'components/forms/LineItemsForm';
import SubtotalArea from './SubtotalArea';
import OtherSection from './OtherSection';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledForm = styled.form`
  width: 750px;
  padding: 10px;
  max-width: 100%;
  font-weight: 500;
`;

class CreateStep extends React.Component {
  render() {
    return (
      <Container>
        <StyledForm onSubmit={this.props.onSubmit}>
          <SavedLineItemsForm
            record={this.props.invoice}
            currencySymbol={this.props.currencySymbol}
            onChange={this.props.onChange}
            keys={this.props.keys}
          />
          <LineItemsForm
            onChange={this.props.onChange}
            currencySymbol={this.props.currencySymbol}
            record={this.props.invoice}
            keys={this.props.keys}
          />
          <SubtotalArea
            onChange={this.props.onChange}
            currencySymbol={this.props.currencySymbol}
            invoice={this.props.invoice}
            keys={this.props.keys}
          />
          <OtherSection
            onChange={this.props.onChange}
            currencySymbol={this.props.currencySymbol}
            invoice={this.props.invoice}
            currentUser={this.props.currentUser}
            keys={this.props.keys}
          />
        </StyledForm>
      </Container>
    );
  }
}

export default CreateStep;



// WEBPACK FOOTER //
// ./src/routes/invoice-create/CreateStep/index.js